import { Label, TextInput } from 'flowbite-react';
import type { FunctionComponent } from 'react';

import { labelSizes, labelVariants, sizeVariants } from '../utils';
import type { InputProps } from './types';

const customTheme = {
  base: 'flex',
  field: {
    base: 'relative w-full',
    icon: {
      base: 'pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3',
      svg: 'h-5 w-5 text-dark'
    },
    rightIcon: {
      base: 'pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3',
      svg: 'h-4 w-4 text-dark'
    },
    input: {
      base: 'block w-full disabled:cursor-not-allowed disabled:opacity-50 dark:bg-bg_dark dark:text-n700_text_dark_mode',
      sizes: {
        sm: 'p-1.5 text-sm',
        md: 'p-2 text-base',
        lg: 'p-3 text-lg'
      },
      colors: {
        default:
          'border placeholder-n400_input_stroker !border-n200_background focus:!ring-n400_input_stroker focus:!border-n400_input_stroker dark:placeholder-n700_text_dark_mode',
        error: '!border-brand focus:!border-brand focus:!ring-brand'
      },
      withRightIcon: {
        on: 'pr-10',
        off: ''
      },
      withIcon: {
        on: 'pl-10',
        off: ''
      },
      withAddon: {
        on: 'rounded-r-lg',
        off: 'rounded-lg'
      }
    }
  }
};

export const Input: FunctionComponent<InputProps> = ({
  label,
  id,
  labelStyle = 'normal',
  sizing = 'medium',
  color = 'default',
  className,
  icon,
  containerClassname,
  error = '',
  isError = false,
  ...props
}) => {
  return (
    <div className={`relative ${containerClassname}`}>
      {label && (
        <Label htmlFor={id} className={`block mb-2 text-dark text-base ${labelVariants[labelStyle]} ${labelSizes[sizing]}`}>
          {label}
        </Label>
      )}

      <TextInput
        {...props}
        color={error || isError ? 'error' : color}
        theme={{
          ...customTheme,
          field: {
            ...customTheme.field,
            input: { ...customTheme.field.input, base: `${customTheme.field.input.base} ${icon ? '!pr-6' : ''}` }
          }
        }}
        className={className}
        type='text'
        sizing={sizeVariants[sizing]}
      />
      {icon && <div className='absolute top-5 right-2'>{icon}</div>}
      {error && <p className='!text-brand font-medium text-xs mt-1 break-words w-[450px]'>{error}</p>}
    </div>
  );
};
